<template>
  <div data-component="image">
    <img :src="output" :alt="data.alt" />
  </div>
</template>

<script>
// Module expects:
// - src
// - alt (description text)
export default {
  name: 'component_image',
  props: ['data'],
  computed: {
    output: function() {
      let output;
      const window = this.data.window;

      if (this.data.srcSet) {
        output = this.data.srcSet.find(function(img) {
          return window.width < img.max;
        });
      }

      if (output) {
        output = output.src;
      } else {
        output = this.data.src;
      }

      return output;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-component="image"] {
    & > img {
      margin: 0 auto;
      display: block;
      max-width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/image.vue